/**
 * Vignettes de couleur personnalisées dans le bloc « Offres par quantité ».
 *
 * Le thème affiche la photo du produit à gauche de chaque sélecteur. Ce script
 * la remplace par la texture associée au coloris, définie dans les réglages du
 * bloc (libellé du coloris -> image). Il repasse après le script du thème, qui
 * réécrit la vignette à chaque changement de sélection.
 */
(function () {
  function readMap(container) {
    try {
      return JSON.parse(container.getAttribute('data-qb-swatches') || '{}');
    } catch (e) {
      return {};
    }
  }

  function labelOf(select) {
    var opt = select.options[select.selectedIndex];
    return opt ? opt.textContent.trim().toLowerCase() : '';
  }

  function apply(row, map) {
    var select = row.querySelector('[data-ref="quantity-break-variant-picker"]');
    var holder = row.querySelector('[data-ref="quantity-break-variant-thumbnail"]');
    if (!select || !holder) return;

    var url = map[labelOf(select)];
    if (!url) return;

    var img = holder.querySelector('img');
    if (!img) {
      img = document.createElement('img');
      img.width = 48;
      img.height = 48;
      img.loading = 'lazy';
      holder.appendChild(img);
    }
    if (img.getAttribute('src') !== url) img.setAttribute('src', url);
    img.setAttribute('alt', '');
    holder.classList.remove('quantity-break__variant-thumbnail--hidden');
  }

  /**
   * Bundle V2 : la grande photo de chaque article suit le coloris choisi.
   * Elle est écrite une fois par le serveur ; le thème ne rafraîchit que la
   * petite pastille. On met donc la photo à jour nous-mêmes.
   */
  function refreshBogoPhotos(container) {
    container.querySelectorAll('[data-kalm-bogo-select]').forEach(function (select) {
      var unit = select.closest('[data-kalm-bogo-unit]');
      if (!unit) return;

      var holder = unit.querySelector('[data-kalm-bogo-media]');
      if (!holder) return;

      var opt = select.options[select.selectedIndex];
      var url = opt && opt.getAttribute('data-variant-photo');
      if (!url) return;

      var img = holder.querySelector('img');
      if (!img) {
        img = document.createElement('img');
        img.width = 130;
        img.height = 130;
        img.loading = 'lazy';
        img.alt = '';
        holder.appendChild(img);
      }
      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
    });
  }

  function refresh(container) {
    refreshBogoPhotos(container);
    var map = readMap(container);
    if (!Object.keys(map).length) return;
    container.querySelectorAll('.quantity-break__variant-picker-row').forEach(function (row) {
      apply(row, map);
    });
  }

  /**
   * Synchronise le carrousel photo du produit avec le coloris choisi.
   * Reprend la logique du thème (product-media-gallery.js) : on récupère la
   * page du produit pour cette variante et on remplace le carrousel par celui
   * de la réponse. On ne diffuse PAS l'événement « variant:updated » du thème,
   * pour ne réveiller aucun autre composant : le bundle gère lui-même le panier.
   */
  var galleryController = null;

  /**
   * Voie rapide : le carrousel contient DÉJÀ toutes les photos du produit.
   * Changer de coloris ne fait que changer celle qu'on regarde. On demande
   * donc simplement au carrousel d'aller sur la bonne diapositive, via
   * l'instance Splide que `slider.js` garde sur l'élément.
   * Aucune requête réseau : l'affichage est immédiat.
   *
   * @returns {boolean} vrai si le déplacement a eu lieu
   */
  function jumpToMedia(mediaId) {
    if (!mediaId) return false;

    var gallery = document.querySelector('product-media-gallery slider-component');
    if (!gallery || !gallery.slider || typeof gallery.slider.go !== 'function') return false;

    // Les clones sont EXCLUS. En boucle infinie, Splide duplique des
    // diapositives en tete et en queue de liste : elles portent le meme
    // `data-media-id` que l'originale, et surtout elles decalent la position
    // dans le DOM par rapport a l'index attendu par `go()`. Compter les clones
    // faisait donc arriver systematiquement quelques photos plus loin.
    var slides = gallery.querySelectorAll('[data-ref="main-slider"] .splide__slide:not(.splide__slide--clone)');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-media-id') === String(mediaId)) {
        gallery.slider.go(i);
        return true;
      }
    }
    return false;
  }

  function syncGallery(container, variantId, mediaId) {
    if (container.getAttribute('data-qb-sync-gallery') !== 'true') return;
    if (!variantId) return;

    // le carrousel contient la photo : on s'y rend, sans rien demander au serveur
    if (jumpToMedia(mediaId)) return;

    // repli : la photo n'est pas dans le carrousel, on recharge la galerie
    var base = container.getAttribute('data-qb-product-url') || window.location.pathname;
    if (galleryController) galleryController.abort();
    galleryController = new AbortController();

    fetch(base + (base.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(variantId), {
      signal: galleryController.signal,
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var next = doc.querySelector('product-media-gallery slider-component');
        var current = document.querySelector('product-media-gallery slider-component');
        if (!next || !current) return;
        if (current.innerHTML !== next.innerHTML) current.replaceWith(next);
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') console.error(error);
      });
  }

  function init() {
    document.querySelectorAll('[data-qb-swatches]').forEach(function (container) {
      if (container.dataset.qbSwatchesBound === '1') {
        refresh(container);
        return;
      }
      container.dataset.qbSwatchesBound = '1';
      refresh(container);

      // le script du theme reecrit la vignette : on repasse juste apres
      container.addEventListener('change', function (event) {
        if (!event.target.matches('[data-ref="quantity-break-variant-picker"]')) return;
        var chosen = event.target.options[event.target.selectedIndex];
        syncGallery(container, event.target.value, chosen && chosen.getAttribute('data-media-id'));
        setTimeout(function () {
          refresh(container);
        }, 0);
      });

      // la carte retenue est reconstruite au clic sur l'autre offre
      container.addEventListener('click', function () {
        setTimeout(function () {
          refresh(container);
        }, 0);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
